// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/deal_file.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Upload } from "./file_pb";
import { file_api_proto_v1_file } from "./file_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/deal_file.proto.
 */
export const file_api_proto_v1_deal_file: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_proto_v1_file, file_google_protobuf_timestamp]);

/**
 * フォルダ情報
 *
 * @generated from message api_proto.v1.DealFolder
 */
export type DealFolder = Message<"api_proto.v1.DealFolder"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 deal_id = 2;
   */
  dealId: bigint;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: int64 file_count = 4;
   */
  fileCount: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * フォルダ内のファイル一覧
   *
   * @generated from field: repeated api_proto.v1.DealFile files = 7;
   */
  files: DealFile[];
};

/**
 * Describes the message api_proto.v1.DealFolder.
 * Use `create(DealFolderSchema)` to create a new message.
 */
export const DealFolderSchema: GenMessage<DealFolder> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 0);

/**
 * ファイル情報
 *
 * @generated from message api_proto.v1.DealFile
 */
export type DealFile = Message<"api_proto.v1.DealFile"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 deal_id = 2;
   */
  dealId: bigint;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * @generated from field: string content_type = 5;
   */
  contentType: string;

  /**
   * @generated from field: int64 file_size = 6;
   */
  fileSize: bigint;

  /**
   * @generated from field: optional int64 folder_id = 7;
   */
  folderId?: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api_proto.v1.DealFile.
 * Use `create(DealFileSchema)` to create a new message.
 */
export const DealFileSchema: GenMessage<DealFile> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 1);

/**
 * ファイル数の返却
 *
 * @generated from message api_proto.v1.GetDealFileCountRequest
 */
export type GetDealFileCountRequest = Message<"api_proto.v1.GetDealFileCountRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;
};

/**
 * Describes the message api_proto.v1.GetDealFileCountRequest.
 * Use `create(GetDealFileCountRequestSchema)` to create a new message.
 */
export const GetDealFileCountRequestSchema: GenMessage<GetDealFileCountRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 2);

/**
 * @generated from message api_proto.v1.GetDealFileCountResponse
 */
export type GetDealFileCountResponse = Message<"api_proto.v1.GetDealFileCountResponse"> & {
  /**
   * @generated from field: int64 file_count = 1;
   */
  fileCount: bigint;
};

/**
 * Describes the message api_proto.v1.GetDealFileCountResponse.
 * Use `create(GetDealFileCountResponseSchema)` to create a new message.
 */
export const GetDealFileCountResponseSchema: GenMessage<GetDealFileCountResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 3);

/**
 * ファイル一覧の返却
 *
 * @generated from message api_proto.v1.GetDealFilesRequest
 */
export type GetDealFilesRequest = Message<"api_proto.v1.GetDealFilesRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;
};

/**
 * Describes the message api_proto.v1.GetDealFilesRequest.
 * Use `create(GetDealFilesRequestSchema)` to create a new message.
 */
export const GetDealFilesRequestSchema: GenMessage<GetDealFilesRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 4);

/**
 * @generated from message api_proto.v1.GetDealFilesResponse
 */
export type GetDealFilesResponse = Message<"api_proto.v1.GetDealFilesResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.DealFolder folders = 1;
   */
  folders: DealFolder[];

  /**
   * @generated from field: repeated api_proto.v1.DealFile files = 2;
   */
  files: DealFile[];
};

/**
 * Describes the message api_proto.v1.GetDealFilesResponse.
 * Use `create(GetDealFilesResponseSchema)` to create a new message.
 */
export const GetDealFilesResponseSchema: GenMessage<GetDealFilesResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 5);

/**
 * ファイルの一括アップロード
 *
 * @generated from message api_proto.v1.UploadDealFilesRequest
 */
export type UploadDealFilesRequest = Message<"api_proto.v1.UploadDealFilesRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * @generated from field: repeated api_proto.v1.Upload data_list = 2;
   */
  dataList: Upload[];

  /**
   * @generated from field: optional int64 folder_id = 3;
   */
  folderId?: bigint;
};

/**
 * Describes the message api_proto.v1.UploadDealFilesRequest.
 * Use `create(UploadDealFilesRequestSchema)` to create a new message.
 */
export const UploadDealFilesRequestSchema: GenMessage<UploadDealFilesRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 6);

/**
 * @generated from message api_proto.v1.UploadDealFilesResponse
 */
export type UploadDealFilesResponse = Message<"api_proto.v1.UploadDealFilesResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.DealFile files = 1;
   */
  files: DealFile[];
};

/**
 * Describes the message api_proto.v1.UploadDealFilesResponse.
 * Use `create(UploadDealFilesResponseSchema)` to create a new message.
 */
export const UploadDealFilesResponseSchema: GenMessage<UploadDealFilesResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 7);

/**
 * フォルダ作成
 *
 * @generated from message api_proto.v1.CreateDealFolderRequest
 */
export type CreateDealFolderRequest = Message<"api_proto.v1.CreateDealFolderRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message api_proto.v1.CreateDealFolderRequest.
 * Use `create(CreateDealFolderRequestSchema)` to create a new message.
 */
export const CreateDealFolderRequestSchema: GenMessage<CreateDealFolderRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 8);

/**
 * @generated from message api_proto.v1.CreateDealFolderResponse
 */
export type CreateDealFolderResponse = Message<"api_proto.v1.CreateDealFolderResponse"> & {
  /**
   * @generated from field: api_proto.v1.DealFolder folder = 1;
   */
  folder?: DealFolder;
};

/**
 * Describes the message api_proto.v1.CreateDealFolderResponse.
 * Use `create(CreateDealFolderResponseSchema)` to create a new message.
 */
export const CreateDealFolderResponseSchema: GenMessage<CreateDealFolderResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 9);

/**
 * フォルダ名前変更
 *
 * @generated from message api_proto.v1.RenameDealFolderRequest
 */
export type RenameDealFolderRequest = Message<"api_proto.v1.RenameDealFolderRequest"> & {
  /**
   * @generated from field: int64 folder_id = 1;
   */
  folderId: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message api_proto.v1.RenameDealFolderRequest.
 * Use `create(RenameDealFolderRequestSchema)` to create a new message.
 */
export const RenameDealFolderRequestSchema: GenMessage<RenameDealFolderRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 10);

/**
 * @generated from message api_proto.v1.RenameDealFolderResponse
 */
export type RenameDealFolderResponse = Message<"api_proto.v1.RenameDealFolderResponse"> & {
  /**
   * @generated from field: api_proto.v1.DealFolder folder = 1;
   */
  folder?: DealFolder;
};

/**
 * Describes the message api_proto.v1.RenameDealFolderResponse.
 * Use `create(RenameDealFolderResponseSchema)` to create a new message.
 */
export const RenameDealFolderResponseSchema: GenMessage<RenameDealFolderResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 11);

/**
 * フォルダへのファイル移動
 *
 * @generated from message api_proto.v1.MoveDealFilesToFolderRequest
 */
export type MoveDealFilesToFolderRequest = Message<"api_proto.v1.MoveDealFilesToFolderRequest"> & {
  /**
   * @generated from field: repeated int64 file_ids = 1;
   */
  fileIds: bigint[];

  /**
   * 移動先フォルダID。未指定の場合はフォルダ外（ルート）に移動
   *
   * @generated from field: optional int64 folder_id = 2;
   */
  folderId?: bigint;
};

/**
 * Describes the message api_proto.v1.MoveDealFilesToFolderRequest.
 * Use `create(MoveDealFilesToFolderRequestSchema)` to create a new message.
 */
export const MoveDealFilesToFolderRequestSchema: GenMessage<MoveDealFilesToFolderRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 12);

/**
 * @generated from message api_proto.v1.MoveDealFilesToFolderResponse
 */
export type MoveDealFilesToFolderResponse = Message<"api_proto.v1.MoveDealFilesToFolderResponse"> & {
};

/**
 * Describes the message api_proto.v1.MoveDealFilesToFolderResponse.
 * Use `create(MoveDealFilesToFolderResponseSchema)` to create a new message.
 */
export const MoveDealFilesToFolderResponseSchema: GenMessage<MoveDealFilesToFolderResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 13);

/**
 * ファイル名前変更
 *
 * @generated from message api_proto.v1.RenameDealFileRequest
 */
export type RenameDealFileRequest = Message<"api_proto.v1.RenameDealFileRequest"> & {
  /**
   * @generated from field: int64 file_id = 1;
   */
  fileId: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message api_proto.v1.RenameDealFileRequest.
 * Use `create(RenameDealFileRequestSchema)` to create a new message.
 */
export const RenameDealFileRequestSchema: GenMessage<RenameDealFileRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 14);

/**
 * @generated from message api_proto.v1.RenameDealFileResponse
 */
export type RenameDealFileResponse = Message<"api_proto.v1.RenameDealFileResponse"> & {
  /**
   * @generated from field: api_proto.v1.DealFile file = 1;
   */
  file?: DealFile;
};

/**
 * Describes the message api_proto.v1.RenameDealFileResponse.
 * Use `create(RenameDealFileResponseSchema)` to create a new message.
 */
export const RenameDealFileResponseSchema: GenMessage<RenameDealFileResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 15);

/**
 * フォルダ削除（フォルダ内のファイルも削除）
 *
 * @generated from message api_proto.v1.DeleteDealFolderRequest
 */
export type DeleteDealFolderRequest = Message<"api_proto.v1.DeleteDealFolderRequest"> & {
  /**
   * @generated from field: int64 folder_id = 1;
   */
  folderId: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteDealFolderRequest.
 * Use `create(DeleteDealFolderRequestSchema)` to create a new message.
 */
export const DeleteDealFolderRequestSchema: GenMessage<DeleteDealFolderRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 16);

/**
 * ファイルの一括削除
 *
 * @generated from message api_proto.v1.DeleteDealFilesRequest
 */
export type DeleteDealFilesRequest = Message<"api_proto.v1.DeleteDealFilesRequest"> & {
  /**
   * @generated from field: repeated int64 file_ids = 1;
   */
  fileIds: bigint[];
};

/**
 * Describes the message api_proto.v1.DeleteDealFilesRequest.
 * Use `create(DeleteDealFilesRequestSchema)` to create a new message.
 */
export const DeleteDealFilesRequestSchema: GenMessage<DeleteDealFilesRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 17);

/**
 * presigned PUT URL発行
 *
 * @generated from message api_proto.v1.CreateDealFileUploadUrlRequest
 */
export type CreateDealFileUploadUrlRequest = Message<"api_proto.v1.CreateDealFileUploadUrlRequest"> & {
  /**
   * @generated from field: string deal_id = 1;
   */
  dealId: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: string content_type = 3;
   */
  contentType: string;

  /**
   * @generated from field: int64 file_size = 4;
   */
  fileSize: bigint;
};

/**
 * Describes the message api_proto.v1.CreateDealFileUploadUrlRequest.
 * Use `create(CreateDealFileUploadUrlRequestSchema)` to create a new message.
 */
export const CreateDealFileUploadUrlRequestSchema: GenMessage<CreateDealFileUploadUrlRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 18);

/**
 * @generated from message api_proto.v1.CreateDealFileUploadUrlResponse
 */
export type CreateDealFileUploadUrlResponse = Message<"api_proto.v1.CreateDealFileUploadUrlResponse"> & {
  /**
   * @generated from field: string upload_url = 1;
   */
  uploadUrl: string;

  /**
   * @generated from field: string r2_key = 2;
   */
  r2Key: string;
};

/**
 * Describes the message api_proto.v1.CreateDealFileUploadUrlResponse.
 * Use `create(CreateDealFileUploadUrlResponseSchema)` to create a new message.
 */
export const CreateDealFileUploadUrlResponseSchema: GenMessage<CreateDealFileUploadUrlResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 19);

/**
 * アップロード完了後のDB登録
 *
 * @generated from message api_proto.v1.FinalizeDealFileUploadRequest
 */
export type FinalizeDealFileUploadRequest = Message<"api_proto.v1.FinalizeDealFileUploadRequest"> & {
  /**
   * @generated from field: string deal_id = 1;
   */
  dealId: string;

  /**
   * @generated from field: string r2_key = 2;
   */
  r2Key: string;

  /**
   * @generated from field: string file_name = 3;
   */
  fileName: string;

  /**
   * @generated from field: string content_type = 4;
   */
  contentType: string;

  /**
   * @generated from field: int64 file_size = 5;
   */
  fileSize: bigint;

  /**
   * @generated from field: optional string folder_id = 6;
   */
  folderId?: string;
};

/**
 * Describes the message api_proto.v1.FinalizeDealFileUploadRequest.
 * Use `create(FinalizeDealFileUploadRequestSchema)` to create a new message.
 */
export const FinalizeDealFileUploadRequestSchema: GenMessage<FinalizeDealFileUploadRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 20);

/**
 * @generated from message api_proto.v1.FinalizeDealFileUploadResponse
 */
export type FinalizeDealFileUploadResponse = Message<"api_proto.v1.FinalizeDealFileUploadResponse"> & {
  /**
   * @generated from field: api_proto.v1.DealFile file = 1;
   */
  file?: DealFile;
};

/**
 * Describes the message api_proto.v1.FinalizeDealFileUploadResponse.
 * Use `create(FinalizeDealFileUploadResponseSchema)` to create a new message.
 */
export const FinalizeDealFileUploadResponseSchema: GenMessage<FinalizeDealFileUploadResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 21);

/**
 * 案件ファイル画像の回転
 * 案件ファイル画面 / 現地調査報告書 / 施工事例記事の 3 入口で共有する
 * （権限だけが違い、処理は同一。rpc は company_service.proto 側で 3 本宣言している）。
 *
 * @generated from message api_proto.v1.RotateDealFileImageRequest
 */
export type RotateDealFileImageRequest = Message<"api_proto.v1.RotateDealFileImageRequest"> & {
  /**
   * @generated from field: int64 file_id = 1;
   */
  fileId: bigint;

  /**
   * @generated from field: api_proto.v1.ImageRotation rotation = 2;
   */
  rotation: ImageRotation;
};

/**
 * Describes the message api_proto.v1.RotateDealFileImageRequest.
 * Use `create(RotateDealFileImageRequestSchema)` to create a new message.
 */
export const RotateDealFileImageRequestSchema: GenMessage<RotateDealFileImageRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 22);

/**
 * @generated from message api_proto.v1.RotateDealFileImageResponse
 */
export type RotateDealFileImageResponse = Message<"api_proto.v1.RotateDealFileImageResponse"> & {
  /**
   * 回転後のファイル。url は新しく発行した presigned URL（キーは回転前と同じ。画像は上書きされる）
   *
   * @generated from field: api_proto.v1.DealFile file = 1;
   */
  file?: DealFile;
};

/**
 * Describes the message api_proto.v1.RotateDealFileImageResponse.
 * Use `create(RotateDealFileImageResponseSchema)` to create a new message.
 */
export const RotateDealFileImageResponseSchema: GenMessage<RotateDealFileImageResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 23);

/**
 * 案件ファイルの一括ダウンロード（zip）
 * folder_id 未指定: 案件全体のファイルをzip化
 * folder_id 指定: フォルダ内のファイルのみzip化
 * レスポンスは server-streaming で zip バイナリをチャンク送信する.
 * file_name は最初のチャンクで送信され、以降は zip_data のみ送信される.
 *
 * @generated from message api_proto.v1.DownloadDealFilesAsZipRequest
 */
export type DownloadDealFilesAsZipRequest = Message<"api_proto.v1.DownloadDealFilesAsZipRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * @generated from field: optional int64 folder_id = 2;
   */
  folderId?: bigint;
};

/**
 * Describes the message api_proto.v1.DownloadDealFilesAsZipRequest.
 * Use `create(DownloadDealFilesAsZipRequestSchema)` to create a new message.
 */
export const DownloadDealFilesAsZipRequestSchema: GenMessage<DownloadDealFilesAsZipRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 24);

/**
 * @generated from message api_proto.v1.DownloadDealFilesAsZipResponse
 */
export type DownloadDealFilesAsZipResponse = Message<"api_proto.v1.DownloadDealFilesAsZipResponse"> & {
  /**
   * @generated from field: bytes zip_data = 1;
   */
  zipData: Uint8Array;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * Describes the message api_proto.v1.DownloadDealFilesAsZipResponse.
 * Use `create(DownloadDealFilesAsZipResponseSchema)` to create a new message.
 */
export const DownloadDealFilesAsZipResponseSchema: GenMessage<DownloadDealFilesAsZipResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_file, 25);

/**
 * 画像の回転
 *
 * 時計回りの回転角。90 度単位のみ（左回転は 270 度で表す）。
 * 画像の実体そのものを回転して置き換えるため、この写真を参照する
 * 現地調査報告書・施工事例記事は作成時期を問わず回転後の向きになる。
 *
 * @generated from enum api_proto.v1.ImageRotation
 */
export enum ImageRotation {
  /**
   * 未指定（不正な要求として扱う。「回転しない」ではない）
   *
   * @generated from enum value: IMAGE_ROTATION_UNSPECIFIED = 0;
   */
  IMAGE_ROTATION_UNSPECIFIED = 0,

  /**
   * 時計回りに 90 度
   *
   * @generated from enum value: IMAGE_ROTATION_90 = 1;
   */
  IMAGE_ROTATION_90 = 1,

  /**
   * 180 度
   *
   * @generated from enum value: IMAGE_ROTATION_180 = 2;
   */
  IMAGE_ROTATION_180 = 2,

  /**
   * 時計回りに 270 度（= 反時計回りに 90 度）
   *
   * @generated from enum value: IMAGE_ROTATION_270 = 3;
   */
  IMAGE_ROTATION_270 = 3,
}

/**
 * Describes the enum api_proto.v1.ImageRotation.
 */
export const ImageRotationSchema: GenEnum<ImageRotation> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_deal_file, 0);

